import { within, userEvent } from "@storybook/test";
import {
  GET_LANDING_PAGE_QUERY,
  GET_CONTRACTS_QUERY,
} from "components/pages/LandingPages/data/queries";
import LandingPageEdit from "../LandingPageEdit";
import SampleLandingPage from "test_support/data/SampleLandingPage";
import SampleContracts from "test_support/data/SampleContracts";
import { cloneDeep, set } from "lodash-es";
import OutletContainer from "components/layout/OutletContainer/OutletContainer";

export default {
  title: "Pages/LandingPageEditMulti/Questions_versions",
  component: LandingPageEdit,
  parameters: {
    zeplinLink: "https://zpl.io/YYdW51k",
  },
};

const Template = (args) => {
  return (
    <OutletContainer>
      <LandingPageEdit {...args} />
    </OutletContainer>
  );
};

export const ExpandedQuestions = Template.bind({});
ExpandedQuestions.args = {};

ExpandedQuestions.parameters = {
  orbit: {
    user: {
      accessibleVendorIds: ['1'],
    },
    records: [
      {
        type: "vendors",
        id: "1",
        attributes: {
          id: 1,
          name: "Cygnus Education",
        },
      },
    ],
  },
  reactRouter: {
    routePath: "/vendors/:vendorId/landing-pages/:landingPageId/*",
    routeParams: { vendorId: "1", landingPageId: "d5a493a9" },
    browserPath: "/vendors/1/landing-pages/d5a493a9/questions",
  },
  providers: {
    apollo: {
      mocks: [
        {
          request: {
            query: GET_LANDING_PAGE_QUERY,
            variables: {
              id: "d5a493a9",
            },
          },
          result: {
            data: {
              landingPage: SampleLandingPage,
            },
          },
        },
        {
          request: {
            query: GET_CONTRACTS_QUERY,
            variables: {
              clientIds: ["188", "29", "184", "195"],
              vendorId: "1",
            },
          },
          result: {
            data: {
              contracts: SampleContracts,
            },
          },
        },
      ],
    },
  },
};

ExpandedQuestions.play = async ({ canvasElement }) => {
  const step2 = await within(canvasElement).findByRole("group", {
    name: /Step 2/,
  });
  const expandButton = await within(step2).findByRole("button", {
    name: /expand/i,
  });

  await userEvent.click(expandButton);
};

export const QuestionsWithPersistedErrors = Template.bind({});
QuestionsWithPersistedErrors.args = {};

// workaround for overly aggressive caching in suspendedQuery
// create mock request with different variables
let errorParams = cloneDeep(SampleLandingPage);
set(errorParams, "steps[0].questions[0].text", "");
QuestionsWithPersistedErrors.parameters = {
  ...ExpandedQuestions.parameters,
  reactRouter: {
    routePath: "/vendors/:vendorId/landing-pages/:landingPageId/*",
    routeParams: { vendorId: "1", landingPageId: "d5a493a9-error" },
    browserPath: "/vendors/1/landing-pages/d5a493a9-error/questions",
  },
  providers: {
    apollo: {
      mocks: [
        {
          request: {
            query: GET_LANDING_PAGE_QUERY,
            variables: {
              id: "d5a493a9-error",
            },
          },
          result: {
            data: {
              landingPage: errorParams,
            },
          },
        },
        {
          request: {
            query: GET_CONTRACTS_QUERY,
            variables: {
              clientIds: ["188", "29", "184", "195"],
              vendorId: "1",
            },
          },
          result: {
            data: {
              contracts: SampleContracts,
            },
          },
        },
      ],
    },
  },
};
